import { render, staticRenderFns } from "./ViewMyAcademy.vue?vue&type=template&id=fd5f4eea&scoped=true"
import script from "./ViewMyAcademy.vue?vue&type=script&lang=js"
export * from "./ViewMyAcademy.vue?vue&type=script&lang=js"
import style0 from "./ViewMyAcademy.vue?vue&type=style&index=0&id=fd5f4eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5f4eea",
  null
  
)

export default component.exports